import { Component, Injector, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    BusquedaUrgenciasGetListQuery,
    ControlEstatusGetAcftivoByPacienteIdQuery,
    ControlEstatusPacienteServiceProxy,
    IntegracionIMSSServiceProxy,
    PatientResponse,
} from '../../../../shared/service-proxies/service-proxies';
import { EditPatientComponent } from '../../../catalogs/patients/editpatient.component';
import { AppComponent } from '../../../app.component';

@Component({
    selector: 'app-paciente-seleccionado',
    templateUrl: 'paciente-seleccionado.component.html',
    providers: [AppComponent]
})
export class PacienteSeleccionadoComponent extends AppComponentBase implements OnInit {

    /* @Output() removePatient: EventEmitter<any> = new EventEmitter<any>();*/

    form: FormGroup;
    loading = false;
    blockedDocument = false;

    pacienteSeleccionado: PatientResponse;
    permissions: any;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
        private controlEtatusService: ControlEstatusPacienteServiceProxy,
        private integracionIMSSService: IntegracionIMSSServiceProxy
    ) {
        super(injector);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    ngOnInit() {
        const self = this;

        self.permissions = {
            editPatient: self.permission.isGranted('Catalogos.Patients.Edit')
        };

        self.prepareForm();

        // Se suscribe al servicio de búsqueda de pacientes
        this.busquedaPacienteService.pacienteSeleccionado.subscribe(m => {
            self.pacienteSeleccionado = m;
            if (self.pacienteSeleccionado) {
                self.setPaciente(self.pacienteSeleccionado);
            } else {
                self.prepareForm();
            }
        });
    }

    setPaciente(pac: PatientResponse): void {
        const self = this;

        self.pacienteSeleccionado = pac;

        self.f.idSair.setValue(self.pacienteSeleccionado.id);
        self.f.nombre.setValue(self.pacienteSeleccionado.fullName);
        self.f.nss.setValue(self.pacienteSeleccionado.nss);
        self.f.sexo.setValue(self.pacienteSeleccionado.sexDesc);
        self.f.hospitalId.setValue(self.pacienteSeleccionado.umf);
        self.f.hospital.setValue(self.pacienteSeleccionado.umfDesc);
        self.f.clavePresupuestal.setValue(self.pacienteSeleccionado.umfBudgetAccountCode);
        // self.f.estatus.setValue(self.pacienteSeleccionado.sta);
        self.f.tipoPaciente.setValue(self.pacienteSeleccionado.patientTypeImssDesc);
        self.f.agregadoMedico.setValue(self.pacienteSeleccionado.medicalAttache);
        self.f.idee.setValue(self.pacienteSeleccionado.idee);
        self.f.edad.setValue(self.pacienteSeleccionado.age);

        self.getControlEstatus();
    }

    getControlEstatus(): void {
        const self = this;

        const req = new ControlEstatusGetAcftivoByPacienteIdQuery();
        req.pacienteId = self.pacienteSeleccionado.id;

        self.controlEtatusService.getControlEstatusActivoPaciente(req)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                if (data) {
                    self.f.estatus.setValue(data.duracionDesc + ' en ' + data.estatusDesc);
                }
            });
    }

    prepareForm(): void {
        const self = this;

        self.form = self.formBuilder.group({
            idSair: [null],
            nombre: [null],
            nss: [null],
            sexo: [null],
            hospitalId: [null],
            hospital: [null],
            clavePresupuestal: [null],
            estatus: [null],
            tipoPaciente: [null],
            agregadoMedico: [null],
            idee: [null],
            edad: [null]
        });

        self.f.idSair.disable();
        self.f.nombre.disable();
        self.f.nss.disable();
        self.f.sexo.disable();
        self.f.hospital.disable();
        self.f.clavePresupuestal.disable();
        self.f.estatus.disable();
        self.f.tipoPaciente.disable();
        self.f.agregadoMedico.disable();
        self.f.idee.disable();
        self.f.edad.disable();
    }

    quitarPaciente(): void {
        const self = this;
        self.busquedaPacienteService.removePatient();
    }

    editarPaciente(): void {
        const self = this;
        const ref = self.dialogService.open(EditPatientComponent, {
            styleClass: 'd-sm d-md-80 d-lg-80 d-xl-80',
            header: self.l('Catalogos.Patients.Edit.Title'),
            showHeader: true,
            dismissableMask: false,
            // footer: 'DUMMY',
            data: {
                id: self.pacienteSeleccionado.id
            }
        });

        ref.onClose.subscribe((pacienteId: number) => {
            self.busquedaPacienteService.setPatient(self.pacienteSeleccionado);
        });
    }

    buscarIMSS(): void {
        const self = this;

        const filter = new BusquedaUrgenciasGetListQuery();
        filter.nss = self.f.nss.value;

        if (self.f.agregadoMedico.value) {
            filter.agregadoMedico = self.f.agregadoMedico.value.toUpperCase();
        }

        filter.hospitalId = self.f.hospitalId.value;

        self.blockedDocument = true;

        self.integracionIMSSService.getPacientesPorIMSS(filter)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {

                if (data.valido) {
                    const msgs = data.mensajes.join('<br/>');
                    self.alertService.info(msgs);
                }
            });
    }
}
